<h1>Top Navigation Modal!</h1>
<br><br>
<div> This modal is displayed until a URL / routerLink is assigned</div>
<br><br>
<div class="buttons">
  <p-button pRipple type="button" label="Close Modal" (click)="closeModal()" styleClass="p-button-rounded"></p-button>
</div>
